import React from 'react';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { FormCard } from 'pages/provisioning/_components';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/user-preferences/store';
import style from 'pages/user-preferences/style';
import { RuleType } from './ruleType';
import { RuleValue } from './ruleValue';
import { RuleName } from './ruleName';
import { CostCenter } from './costCenter';

const ApprovalsRuleForm = () => {
    const [order, setOrder] = useRecoilState(OrderPayload);

    const addRuleSection = () => {
        if (order?.ruleRows?.length < 3) {
            const newRuleRow = {
                ruleType: null,
                value: null,
            };
            const updatedRuleRows = [...order?.ruleRows, newRuleRow];
            setOrder({
                ...order,
                ruleRows: updatedRuleRows,
            });
        }
    };

    const removeRuleSection = (index) => {
        const updatedRuleRows = order?.ruleRows?.filter((_, i) => i !== index);
        setOrder({
            ...order,
            ruleRows: updatedRuleRows,
        });
    };

    return (
        <Grid container spacing={3.125}>
            <Grid item xs={12}>
                <Grid item xs={12}>
                    <FormCard title="" placement="right">
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                <RuleName />
                            </Grid>
                            <Grid item xs={3}>
                                <CostCenter />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} alignItems="center" sx={{ marginTop: '8px' }}>
                            <Grid item xs={3}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ paddingRight: '8px', fontWeight: 600 }}>RULE TYPE</Box>
                                </Box>
                            </Grid>
                            <Grid item xs={3}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ paddingRight: '8px', fontWeight: 600 }}>VALUE</Box>
                                </Box>
                            </Grid>
                        </Grid>
                        {order?.ruleRows?.map((section, index) => (
                            <Grid container spacing={2} key={index} alignItems="center">
                                <Grid item xs={3}>
                                    <RuleType index={index} />
                                </Grid>
                                <Grid item xs={3}>
                                    <RuleValue index={index} />
                                </Grid>
                                <Grid item xs={0}>
                                    <Box display="flex" alignItems="center" justifyContent="center">
                                        <IconButton
                                            size="large"
                                            onClick={() => removeRuleSection(index)}
                                            sx={{ fontSize: '24px', color: '#FF0000' }}
                                            data-testid={`remove-rule-${index}`}
                                            disabled={order?.ruleRows?.length === 1}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        {index === order?.ruleRows?.length - 1 && (
                                            <IconButton
                                                size="large"
                                                onClick={addRuleSection}
                                                data-testid={`add-rule-${index}`}
                                                sx={{ fontSize: '24px', color: '#0047BA' }}
                                                disabled={order?.ruleRows?.length >= 3}
                                            >
                                                <AddIcon />
                                            </IconButton>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>
                        ))}
                        <Box sx={style?.notes}>
                            <Typography component="span" sx={style?.noteBold}>
                                Note:
                            </Typography>
                            Please select atleast one rule to make your auto approval rule to be enabled.
                        </Box>
                    </FormCard>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ApprovalsRuleForm;
